import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CoreUIFlashToastConfig } from './flash-toast.model';

@Injectable({
  providedIn: 'root',
})
export class CoreUIFlashToastService {
  private toastSubject = new Subject<CoreUIFlashToastConfig>();

  get toasts$(): Observable<CoreUIFlashToastConfig> {
    return this.toastSubject.asObservable();
  }

  show(config: CoreUIFlashToastConfig): void {
    this.toastSubject.next({
      type: 'info',
      position: 'top-center',
      duration: 2500,
      ...config,
    });
  }

  success(message: string, options?: Partial<CoreUIFlashToastConfig>): void {
    this.show({ ...options, message, type: 'success' });
  }

  error(message: string, options?: Partial<CoreUIFlashToastConfig>): void {
    this.show({ ...options, message, type: 'error' });
  }

  warning(message: string, options?: Partial<CoreUIFlashToastConfig>): void {
    this.show({ ...options, message, type: 'warning' });
  }

  info(message: string, options?: Partial<CoreUIFlashToastConfig>): void {
    this.show({ ...options, message, type: 'info' });
  }

  delete(message: string, options?: Partial<CoreUIFlashToastConfig>): void {
    this.show({ ...options, message, type: 'delete' });
  }
}
